export function getQaNameInsuranceButton(name, index) {
  return `${name}_${index + 1}_`
}
